module.exports = __webpack_public_path__ + "static/img/icon_wx.d745de54.png";